var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmileChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.875,
    height: 34.875,
    viewBox: "0 0 34.875 34.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-smile",
    "data-name": "Icon awesome-smile",
    d: "M17.438.563A17.438,17.438,0,1,0,34.875,18,17.434,17.434,0,0,0,17.438.563Zm5.625,11.813a2.25,2.25,0,1,1-2.25,2.25A2.248,2.248,0,0,1,23.063,12.375Zm-11.25,0a2.25,2.25,0,1,1-2.25,2.25A2.248,2.248,0,0,1,11.813,12.375Zm13.7,11.967a10.5,10.5,0,0,1-16.144,0A1.126,1.126,0,0,1,11.1,22.9a8.262,8.262,0,0,0,12.684,0A1.126,1.126,0,0,1,25.509,24.342Z",
    transform: "translate(0 -0.563)",
    fill: "#e8339e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileChat);
export default __webpack_public_path__ + "static/media/smile_chat.36b71d6b360d540ab344745779a78f2b.svg";
export { ForwardRef as ReactComponent };